// extracted by mini-css-extract-plugin
export default {"styledCheckbox":"Checkbox_styledCheckbox__rvssm","checkmark":"Checkbox_checkmark__H3nN5","disabled":"Checkbox_disabled__h5VEk","hiddenCheckbox":"Checkbox_hiddenCheckbox__PbEcU"};